import { render, staticRenderFns } from "./Tabla.vue?vue&type=template&id=ce6b4794"
import script from "./Tabla.vue?vue&type=script&lang=ts"
export * from "./Tabla.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports